import { gql } from "@apollo/client";
import { BagFiltersType } from "../queries/getBagListing";

export const EXPORT_BAG_TAGS = gql`
  mutation ExportBagTags($filters: BagFiltersTypeInput!, $language: String!) {
    exportBagTags(filters: $filters, language: $language)
  }
`;

export interface ExportBagTagsVariables {
  filters: BagFiltersType;
  language: string;
}

export interface ExportBagTagsResponse {
  exportBagTags: string;
}
